// Turns global per-status counts into a per-queue number. Three callers — the
// sidebar badges, the queue header subtitle, and the pipeline KPI row — so it
// lives here rather than being re-derived in each.

import type { ListingRequestQueueConfig } from '../constants/listingRequestQueues'
import type { ListingRequestStatusCounts } from '../types/listingRequestsTypes'

/**
 * How many requests a queue holds. A queue with no status filter (All Requests)
 * reports the grand total; every other queue sums the statuses it lists, so a
 * multi-status queue like Agreements counts both of its buckets.
 *
 * Returns 0 while the counts query is still pending — callers that need to
 * distinguish "loading" from "empty" read the query's `isLoading` instead.
 */
export function countForQueue(
  counts: ListingRequestStatusCounts | undefined,
  queue: ListingRequestQueueConfig,
): number {
  if (!counts) return 0
  if (!queue.statuses.length) return counts.all
  return queue.statuses.reduce((total, status) => total + (counts.byStatus[status] ?? 0), 0)
}

/** Sidebar badges hide at zero — an empty queue is not an alert. */
export function badgeForQueue(
  counts: ListingRequestStatusCounts | undefined,
  queue: ListingRequestQueueConfig,
): number | undefined {
  const count = countForQueue(counts, queue)
  return count > 0 ? count : undefined
}
